import React, { Component } from 'react';
import './header.css';

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<div className="container">
				<header>
					<div className="flexContainerRow">
						<a href="http://arseblog.com" className="logo">
							<img
								src={'https://firebasestorage.googleapis.com/v0/b/arseblogratings.appspot.com/o/logo250-1.png?alt=media&token=7cecb845-6982-4a9f-a032-29196a7867f3'}
								className=""
								alt="arseblog"
							/>
						</a>
						<h2>arseblog ratings admin.</h2>
					</div>
				</header>
			</div>
		);
	}
}

export { Header };



// WEBPACK FOOTER //
// ./src/components/common/header/Header.js